import React, { useState } from "react";
import MonthlyCalenderComponent from "../components/MonthlyCalenderComponent";
import useCommonApi from "../hooks/common-apis";

function MonthlyCalender() {
  return (
    <div>
      <MonthlyCalenderComponent />
    </div>
  );
}

export default MonthlyCalender;
